import {
  BiSheetUploadView,
  BiUploadStatus,
  BiUploadView,
} from '@euler/model/bi/upload';
import { biSheetPhase } from './biUploadPhase';

/** The card's subtitle: where the file is, in a few words. */
export function biUploadSubtitle(view: BiUploadView): string | null {
  switch (view.status) {
    case BiUploadStatus.Uploaded:
      return '正在读取';
    case BiUploadStatus.NeedsSheetSelection: {
      const open = view.sheets.filter(sheet => !sheet.block).length;
      return `${view.sheets.length} 个工作表，${open} 个可以导入`;
    }
    case BiUploadStatus.Failed:
      return '没有导入';
    case BiUploadStatus.Expired:
      return '已结束';
    case BiUploadStatus.Deleted:
      return null;
    default: {
      const chosen = view.sheets.filter(sheet => sheet.upload).length;
      return chosen > 1 ? `选了 ${chosen} 个工作表` : null;
    }
  }
}

/** One sheet upload's step in a word, for the summary of an older card. */
export function biSheetStepText(upload: BiSheetUploadView): string {
  const phase = biSheetPhase(upload);
  switch (phase.kind) {
    case 'working':
      return '处理中';
    case 'confirm':
      return '等待确认列';
    case 'proposals':
      return phase.draftIds.length
        ? `已导入，推荐 ${phase.draftIds.length} 张图表`
        : '已导入';
    case 'failed':
      return '没有导入';
    case 'deleted':
      return '已删除';
  }
}
